"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
function stringify(obj) {
    if (typeof obj !== 'object') {
        return encodeURIComponent(obj);
    }
    var str = [];
    Object.keys(obj || {}).forEach(function (key) {
        var value = obj[key];
        if (value !== '' && value !== undefined) {
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            str.push([key, value].map(encodeURIComponent).join('='));
        }
    });
    return str.join('&');
}
exports.stringify = stringify;
function parse(input) {
    var str = input;
    if (['?', '#'].indexOf(str.substr(0, 1)) !== -1) {
        str = str.substr(1);
    }
    if (str.indexOf('=') === -1) {
        return str;
    }
    return str.split('&').reduce(function (obj, set) {
        var _a = __read(set.split('=').map(decodeURIComponent), 2), key = _a[0], value = _a[1];
        var parsed;
        try {
            parsed = JSON.parse(value);
        }
        catch (err) {
            parsed = value;
        }
        obj[key] = parsed;
        return obj;
    }, {});
}
exports.parse = parse;
//# sourceMappingURL=serialize.js.map